import React, { useState } from "react";
import LoginForm from "./LoginForm";
import RegisterForm from "../register/RegisterForm";
import "./LoginRegister.css";

const LoginRegister = () => {
  const [showRegister, setShowRegister] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState("");

  const handleCreateAccountClick = () => {
    setShowRegister(true);
  };

  const handleBackToLogin = () => {
    setShowRegister(false);
  };

  const handleRegisterSuccess = (email) => {
    setRegisteredEmail(email);
    setShowRegister(false);
  };

  return (
    <div className="login-register-container">
      {/* Gradient Background */}
      

      {/* Form Section */}
      {!showRegister ? (
        <div className="login-form-container">
          <LoginForm 
            setShowRegister={setShowRegister} 
            prefillEmail={registeredEmail}
          />
        </div>
      ) : (
        <RegisterForm
          setShowRegister={setShowRegister}
          onRegisterSuccess={handleRegisterSuccess}
        />
      )}
    </div>
  );
};

export default LoginRegister;
